<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    import enumService from '../services/enumService'
    import accessLevelEnum from '../enums/accessLevel'

    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                claimForm: () => import('../forms/ClaimForm'),
                roleForm: () => import('../forms/RoleForm'),
                fields: [
                    { type: 'autocomplete', text: 'Role', value: 'roleId', rules: [v => !!v || 'Role is required'], isRequired: true, form: () => import('./RoleForm'), apiMethod: 'Roles', claim: 'Roles' },
                    { type: 'autocomplete', text: 'Claim', value: 'claimId', rules: [v => !!v || 'Claim is required'], isRequired: true, form: () => import('./ClaimForm'), apiMethod: 'Claims', claim: 'Claims' },
                    { type: 'enum', text: 'Access Level', value: 'accessLevel', rules: [v => (v !== null && v !== '') || 'Access Level is required'], isRequired: true, items: enumService.enumAsSelectList(accessLevelEnum) },
                ],
                apiMethod: 'RoleClaims',
                formTitle: 'Role Claim',
            }
        },
    };
</script>
